import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [type, setType] = useState('error');

  const show = (msg, severity = 'error') => {
    setMessage(msg);
    setType(severity || 'error');
  };

  const showError = (msg) => show(msg, 'error');
  const showSuccess = (msg) => show(msg, 'success');
  const showWarning = (msg) => show(msg, 'warning');
  const showInfo = (msg) => show(msg, 'info');

  const clear = () => {
    setMessage(null);
  };

  const clearError = clear;

  return (
    <ErrorContext.Provider value={{ message, type, show, showError, showSuccess, showWarning, showInfo, clear, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError deve ser usado dentro de um ErrorProvider');
  }
  return context;
};
